<template>
  <main>
    <tab-header />
    <div class="tab-content" :class="{'section-loading': changeLoading}">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        異動後實質接觸追蹤表
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">受撥月份</label>
                            <div class="col-11">
                                <div class="float-right w-25">
                                    <p class="text-green cus-p">本年度實質接觸</p>
                                    <p class="text-green cus-p">6個月內受撥月份為{{currentYear-1}}/6-{{currentYear}}/5</p>
                                    <p class="text-green cus-p">一年內受撥月份為{{currentYear-2}}/12-{{currentYear-1}}/11</p>
                                    <a target="_blank" href="https://clearning.cathaylife.com.tw/channel/channel-room/67a6c9bdbe21a0562869fabf/67aadda992dc5f5142e195d0/empty/6943ab2422c39a02d4182911"><span class="text-blue">當月對應各指標表格</span></a>
                                </div>
                                <select class="form-control form-control-inline ml-0" v-model="form.startYear">
                                    <option value="">請選擇</option>
                                    <option :value="item.value" v-for="(item, index) in yearSelect" :key="`S-year-${index}`">
                                      {{ item.title }}
                                    </option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.startMonth">
                                    <option value="">請選擇</option>
                                    <option :value="month.value" v-for="(month, index) in monthSelect" :key="`S-month-${index}`">
                                      {{ month.title }}
                                    </option>
                                </select>
                                <span class="text">～</span>
                                <select class="form-control form-control-inline" v-model="form.endYear">
                                    <option value="">請選擇</option>
                                    <option :value="item.value" v-for="(item, index) in yearSelect" :key="`E-year-${index}`">
                                      {{ item.title }}
                                    </option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.endMonth">
                                    <option value="">請選擇</option>
                                    <option :value="month.value" v-for="(month, index) in monthSelect" :key="`E-month-${index}`">
                                      {{ month.title }}
                                    </option>
                                </select>
                                <a @click="searchData()" class="btn btn-primary mt-0">查詢</a>
                                <div class="col-2">
                                    <div class="checkbox">
                                    <input type="checkbox" v-model="form.vip" id="onlyvip" value="true">
                                    <label for="onlyvip">僅顯示VIP</label>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </form>
                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-7">
                            <ul class="breadcrumb-list">
                                <li class="bread"
                                :class="{'active': bread.index === currentTableIndex}"
                                v-for="(bread, i) in breadcrumbs"
                                :key="`bread-${i}`">
                                    <a v-if="bread.index !== currentTableIndex" role="button" 
                                    @click="returnTable(bread, i)">{{bread.name}}</a>
                                    <a v-else role="button" >{{bread.name}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-left">
                          <a v-if="currentTableIndex < '8'" class="btn btn-default" @click="download()" >下載本頁資料</a>
                          <a v-if="currentTableIndex < '7'" @click.prevent="panelOpen('ceadcdChooseModalOpen')" class="btn btn-default">下載轄下資料</a>
                        </div>
                    </div>
                </div>
                <div v-if ="currentTableIndex =='8'" class="col-12">
                <tab52-table
                  :table-data="tableRow"
                />
                </div>
                <div v-else class="col-12">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th v-if="currentTableIndex == '1'" rowspan="2" width="100">系統別</th>
                                <th v-else-if="currentTableIndex == '2'" rowspan="2" width="100">區部</th>
                                <th v-else-if="currentTableIndex == '7'" rowspan="2" width="100">業務員姓名</th>
                                <th v-else rowspan="2" width="100">單位</th>
                                <th class="text-right">應完成<br/>人數</th>
                                <th class="text-right">未完成<br/>人數</th>
                                <th class="text-right">完成人數<br/>(6個月內)</th>
                                <th class="text-right">完成人數<br/>(12個月內)</th>
                                <th class="text-right">完成人數<br/>(13個月以上)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(6個月內)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(12個月內)</th>
                                <th class="text-right">實質接觸率<br/>(人)%<br/>(13個月以上)</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow.length > 0">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`change-trace-${rid}`">
                            <td>
                              <span
                              v-if="currentTableIndex == '1' && rid == tableRow.length -1" >{{row.cedvnm}}</span>
                              <a
                              v-else-if="currentTableIndex == '1'" 
                              @click="clickRender = row.cedvno == '1' ? false : true; toNextTable(row)"
                              class="link text-underline">{{row.cedvnm}}</a>
                              <span v-else-if="currentTableIndex == '7' && rid == tableRow.length -1">{{row.cedvnm}}</span>
                              <span v-else-if="currentTableIndex == '7' && row.is_link == false">{{row.cedvnm}}</span>
                              <a v-else-if="currentTableIndex == '7' && row.is_link == true" @click="searchDetail(row)" class="link text-underline">{{row.cedvnm}}</a>
                              <span v-else-if="currentTableIndex == '7'">{{row.cedvnm}}</span>
                              <span v-else-if="!(currentTableIndex == '7') && row.cedvnm && rid == tableRow.length -1">{{row.cedvnm}}</span>
                              <a v-else-if="!(currentTableIndex == '7') &&row.cedvnm" @click="toNextTable(row)" class="link text-underline">{{row.cedvnm}}</a>
                              <span v-else-if="!(currentTableIndex == '7') && row.ceadnm && rid == tableRow.length -1">{{row.ceadnm}}</span>
                              <a v-else-if="!(currentTableIndex == '7') && row.ceadnm" @click="toNextTable(row)" class="link text-underline">{{row.ceadnm}}</a>

                            </td>
                            <td class="text-right">{{ row.total }}</td>
                            <td class="text-right">{{ row.csnoncontacted_r }}</td>
                            <td class="text-right">{{ row.cscontacted_6 }}</td>
                            <td class="text-right">{{ row.cscontacted_12 }}</td>
                            <td class="text-right">{{ row.cscontacted_1y }}</td>
                            <td class="text-right">{{ row.rate_6 }}%</td>
                            <td class="text-right">{{ row.rate_12 }}%</td>
                            <td class="text-right">{{ row.rate_1y }}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentTableIndex !== ''">
                            <tr>
                                <td class="empty-block bg-white" colspan="9">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="9">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <ol>
                            <li>實質接觸項目同未訪件</li>
                            <li>如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}</li>
                        </ol>
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>

    <ceadcd-Choose-modal
      :open="ceadcdChooseModalOpen"
      :dis="this.dis"
      @close="panelClose('ceadcdChooseModalOpen')"
      @choose="chooseCeadcd"
    />

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import { debuglog } from 'util';
import { getChangeTrace, downloadChangeTrace , getChangeDetail, getContactInfoBySerNo} from '@/service'
import { saveAs } from 'file-saver'
import Tab52Table from '../manager/condition/components/Tab52Table'
import ceadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'

export default {
  name: 'TransferTab51',
  mixins: [commonMixin],
  components: {
    TabHeader,Tab52Table,ceadcdChooseModal
  },
  computed: {
    ...mapGetters([
      
    ]),
    startDate () {  // 計算開始日期
      return `${this.form.startYear}-${this.form.startMonth}-01`
    },
    endDate () {  // 計算結束日期
      let lastDay = new Date(this.form.endYear,this.form.endMonth,0).getDate() + ''
      return `${this.form.endYear}-${this.form.endMonth}-${lastDay.length == 1 ? '0' + lastDay : lastDay}`
    },
    // wayState () {  //  層級路線狀態值
    //   if(this.apiIntiId == '4' || this.apiIntiId == '6') {
    //     return 'R'
    //   }

    //   if(this.apiIntiId == '5') {
    //     return 'S'
    //   }

    //   if(this.clickRender) {
    //     return 'R'
    //   } else {
    //     return 'S'
    //   }
    // },
    apiIntiId () {  //  計算層級顯示初始頁面
      switch(this.managerKey) {
		    case 'SALES_01':
        case 'SALES_MANAGER_01':
        case 'SALES_MANAGER_02':
        case 'SALES_MANAGER_05':
        return '1'
        case 'SALES_MANAGER_06': 
          if(this.agDivNo.substr(3,4)== '0000') {
            return '1'
          } else if(this.agDivNo[2] == '4' && this.agDivNo.substr(4,3)== '000' && this.agfunctionId.includes('3')) {
            return '1'
          } else if(this.agDivNo[2] == '4' && this.agDivNo.substr(4,3)== '000') {
            return '6'
          } else {
            return '7'
          }
        case 'SALES_MANAGER_03':
          return '6'
        case 'SALES_MANAGER_04':
          if(this.agDivNo[2] == '1') {
            return '7'
          } else if(this.agDivNo[2] == '4') {
            return '7'
          }
        default:
          //this.$toast.info({title: '您的身分無法使用此分頁'})
          return '1'
      }
    },
  },
  data () {
    return {
      is_link : false,
      ceadcdChooseModalOpen: false,
      dis: '51',
      agDivNo: '',
      agDivNo_bak:'',
      clcno_lv: '',
      form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      selection: {
        clcno: '', // 收費代號
        clcid: '', // 收費人員ID
      },
      breadcrumbs: [],
      order: {
        index: 1,
        asc: true
      },
      changeLoading: false,
      specialIndexLine: ['1', '2', '3', '5', '7'],  //  專招層級線
      renderIndexLine: ['1', '2', '3', '4', '6', '7'],  //  展業層級線
      tableTreeRefer: [  // 樹狀表格參考對應值
        {index: '1', name: 'change_trace'},
        {index: '2', name: 'change_trace_2'},
        {index: '3', name: 'change_trace_3'},
        {index: '4', name: 'change_trace_44'},
        {index: '5', name: 'change_trace_51'},
        {index: '6', name: 'change_trace_54'},
        {index: '7', name: 'change_trace_6'},
      ],
      dataTree: {
        change_trace: [],
        change_trace_2: [],
        change_trace_3: [],
        change_trace_44: [],
        change_trace_51: [],
        change_trace_54: [],
        change_trace_6: [],
      },
      clickRender: false,
      currentTableIndex: '',//目前Api_id
      nowGroup: '',//目前DivNo
      managerKey: '',   //  業務職等
      agDivNo: '',   //  業務單位代號
      agDivName: '',   //  業務單位名稱
      tableRow: [],
      yearSelect: [],
      monthSelect:[
        {title: '1 月', value: '01'},
        {title: '2 月', value: '02'},
        {title: '3 月', value: '03'},
        {title: '4 月', value: '04'},
        {title: '5 月', value: '05'},
        {title: '6 月', value: '06'},
        {title: '7 月', value: '07'},
        {title: '8 月', value: '08'},
        {title: '9 月', value: '09'},
        {title: '10 月', value: '10'},
        {title: '11 月', value: '11'},
        {title: '12 月', value: '12'},
      ],
      currentYear: new Date().getFullYear()-1911,
      contactInfo: []
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    returnTable (bread ,idx) {  // 回到上一層
      const tableName = bread.tableName
      this.tableRow = [...this.dataTree[tableName]]
      this.currentTableIndex = bread.index
      this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1)      
      this.nowGroup = bread.divNo;
    },
    handleNextIndex (rowData) {  //  計算下一個層級 api_id
      let nextIndex = ''
      const state = this.wayState(this.currentTableIndex,rowData.cedvno)
      if(state == 'S') {
        let currIndex = this.specialIndexLine.indexOf(this.currentTableIndex)
        nextIndex = this.specialIndexLine[currIndex + 1]
      } else {
        let currIndex = this.renderIndexLine.indexOf(this.currentTableIndex)
        nextIndex = this.renderIndexLine[currIndex + 1]
      }
      return nextIndex
    },
    wayState (index, divNo) {  //  層級路線狀態值
      if(index == '3' && divNo.substring(2,3) == '1'){
        return 'S'
      }else if(index == '3' && divNo.substring(2,3) == '4' ){
        return 'R'
      }

      if(index == '4' || index == '6') {
        return 'R'
      }

      if(index == '5') {
        return 'S'
      }

      if(this.clickRender) {
        return 'R'
      } else {
        return 'S'
      }
    },
    toNextTable (rowData) {  // 往下一層
      let nextIndex = this.handleNextIndex(rowData)  //  計算下一個層級 api_id
      this.currentTableIndex = nextIndex // 待修正
      const onlyVip = this.form.vip ? '1' : '0'  //  判斷 VIP
      let divNo = ''
      if (rowData.cedvno) {
        divNo = this.formatGroupNO(rowData.cedvno)  // 判斷 divNo 格式
      } else {
        divNo = this.formatGroupNO(rowData.ceadcd)  // 判斷 divNo 格式
      }
      this.nowGroup = divNo;
      this.changeLoading = true

      // lev2因為專展合併，因此讀取全部
      divNo = nextIndex === "2" ? "null" : divNo;
      getChangeTrace(this.$store.state.userInfo.id, nextIndex, onlyVip, this.startDate, this.endDate, divNo).then(result => {
        this.changeLoading = false
        let tableName = this.handleTableName(nextIndex)  //  代號轉換表格名稱
        if (result.header && "200" == result.header.status) {
          this.dataTree[tableName] = result.body[tableName]
          this.tableRow = result.body[tableName]
          //接觸明細權限
          if(nextIndex == "7"){
            this.tableRow.forEach(vItem => {
                var c = 1
                var a = 1
                if(vItem.clcno){
                  vItem.clcno.forEach(vclcno => {
                    if(vclcno && this.clcno_lv.substr(0,3) == vclcno.substr(0,3)){//前三碼相同
                      if(this.agDivNo.substr(3,1)=='0'){//第四碼為零
                        c = 0;
                      }else if (this.agDivNo.substr(3,1)==vclcno.substr(3,1)){//第四碼不為零但相同
                        if(this.agDivNo.substr(4,1)=='0'){//第五碼為零
                          c = 0;
                        }else if (this.agDivNo.substr(4,1)==vclcno.substr(4,1)){//第五碼不為零但相同
                          c = 0;
                        }else{
                          c = 1;//第五碼不為零且不相同
                        }
                      }else{
                        c = 1;//第四碼不為零且不相同
                      }
                    }else{
                      c = 1;//前三碼不相同
                    }
                  a = a*c;
                });
                if(a == 0){
                  vItem.is_link = true;
                }else{
                  vItem.is_link = false;
                }
              }
            });
           }
          if (rowData.cedvnm) {
            this.breadcrumbs.push({name: rowData.cedvnm, index: nextIndex, tableName: tableName, divNo: divNo})
          } else {
            this.breadcrumbs.push({name: rowData.ceadnm, index: nextIndex, tableName: tableName, divNo: divNo})
          }
        }

        // for 難字 update
        if (nextIndex == "7") {
          this.registerHanlink()
        }
      })
    },
    handleTableName (no) {  //  代號轉換表格名稱
      let reNo = ''
      this.tableTreeRefer.forEach(item => {
        if (item.index == no) {
          reNo = item.name
        }
      })
      return reNo
    },
    formatGroupNO (divno) {  // 判斷 divNo 格式
      switch (this.currentTableIndex) {
        case '1' : return ''
        case '4' : return divno.substr(0,3)
        case '5' : return divno.substr(0,3)
        case '6' : return divno.substr(0,4)
        default : return divno
      }
    },
    searchData () {
      this.currentTableIndex = this.apiIntiId
      const onlyVip = this.form.vip ? '1' : '0'  //  判斷 VIP
      const divNo =  this.formatGroupNO(this.agDivNo)  // 判斷 divNo 格式
      this.nowGroup = divNo;
      this.breadcrumbs = []
      this.changeLoading = true
      getChangeTrace(this.$store.state.userInfo.id, this.apiIntiId, onlyVip, this.startDate, this.endDate, divNo).then(result => {
        this.changeLoading = false
        let tableName = this.handleTableName(this.apiIntiId)  //  代號轉換表格名稱
        if (result.header && "200" == result.header.status) {
          this.dataTree[tableName] = result.body[tableName]
          this.tableRow = result.body[tableName]
          if(this.currentTableIndex == "7"){
            this.tableRow.forEach(vItem => {
              var c = 1
              var a = 1
              if(vItem.clcno){
                vItem.clcno.forEach(vclcno => {
                  if(vclcno && this.clcno_lv.substr(0,3) == vclcno.substr(0,3)){//前三碼相同
                    if(this.agDivNo.substr(3,1)=='0'){//第四碼為零
                      c = 0;
                    }else if (this.agDivNo.substr(3,1)==vclcno.substr(3,1)){//第四碼不為零但相同
                      if(this.agDivNo.substr(4,1)=='0'){//第五碼為零
                        c = 0;
                      }else if (this.agDivNo.substr(4,1)==vclcno.substr(4,1)){//第五碼不為零但相同
                        c = 0;
                      }else{
                        c = 1;//第五碼不為零且不相同
                      }
                    }else{
                      c = 1;//第四碼不為零且不相同
                    }
                  }else{
                    c = 1;//前三碼不相同
                  }
                a = a*c;
              });
              if(a == 0){
                vItem.is_link = true;
              }else{
                 vItem.is_link = false;
              }
            }
          });
           }          
          if (this.apiIntiId == '1') {
            this.breadcrumbs.push({name: '全部', index: '1', tableName: tableName, divNo: divNo})
          } else {
            this.breadcrumbs.push({name: this.agDivName, index: this.apiIntiId, tableName: tableName, divNo: divNo})
          }
        }
      })
    },
    initDate () {
      let nowDate = this.getCurrentDate().split('-')
      //  產生年份 select
      let endY = nowDate[0] - 1911 
      for (let i = 103;i <= endY;i++) {
        this.yearSelect.push({title: `${i} 年`, value: i + 1911 + ''})
      }

      //  初始化結束日期
      this.form.endYear = nowDate[0]
      this.form.endMonth = nowDate[1].length == 1? '0' + nowDate[1] : nowDate[1]
      
      //  初始化開始日期
      var mm = 5;//要往前6個月
      if(nowDate[1] - mm > 0) {
        this.form.startYear = nowDate[0]
        this.form.startMonth = (nowDate[1] - mm + '').length == 1 ? '0' + (nowDate[1] - mm + '') : (nowDate[1] - mm + '')
      } else {
        this.form.startYear = nowDate[0] - 1 + ''
        this.form.startMonth = (nowDate[1] - mm + 12 + '').length == 1 ? '0' + (nowDate[1] - mm + 12 + '') : (nowDate[1] - mm + 12 + '')
      } 
      
    },
    download() {
      this.changeLoading = true;
      // lev2因為專展合併，因此讀取全部
      let group = this.currentTableIndex === "2" ? "null" : this.nowGroup;
      downloadChangeTrace(this.$store.state.userInfo.id, this.currentTableIndex, (this.form.vip ? "1" : "0"), this.startDate, this.endDate, group).then(result => {
        if (result.type == "application/json") {
          //  json 為檔案下載失敗
          //  把回傳的 blob 轉為 文字檔後再用 json parse
          let reader = new FileReader();
          reader.onload = function() {
            let unicodeJsonA = JSON.parse(reader.result);
            if (unicodeJsonA.header.message) {
              vm.setToastMsg(unicodeJsonA.header.message);
            } else {
              vm.setToastMsg("伺服器連線異常");
            }
          };
          reader.readAsText(result);
        } else {
          //  成功取得檔案  進行下載
          var fileName = "異動後實質接觸統計表";
          if (this.breadcrumbs != [] && this.breadcrumbs.length > 0 && this.breadcrumbs[this.breadcrumbs.length - 1].name) {
            fileName += `-${this.breadcrumbs[this.breadcrumbs.length - 1].name}`;
          }
          fileName += `-${new Date().getTime()}.xlsx`;

          saveAs(result, fileName);
        }

        this.changeLoading = false;
      });
    },
    searchDetail (row) {
      this.selection.clcno = "";//row.clcno
      this.selection.clcid = row.cedvno;
      const onlyVip = this.form.vip ? '1' : '0'  //  判斷 VIP
      this.initDivNoAndClcno();
      // 轄下異動後實質接觸明細
      getChangeDetail(this.$store.state.userInfo.id, this.agDivNo_bak, this.clcno_lv, this.startDate, this.endDate, this.selection.clcno, this.selection.clcid, onlyVip).then(result => { 
        if (result.header && "200" == result.header.status) {
          this.tableRow = result.body.notice_list
          this.currentTableIndex ='8';         
        }
        this.registerHanlink()
      })
    },
    initDivNoAndClcno() {
      this.agDivNo_bak = this.$store.state.userInfo.divNo.substr(0,3)
      let clcno = this.$store.state.userInfo.divNo
      if(this.$store.state.userInfo.divNo.substr(2, 1) == '4') {
        clcno = this.$store.state.userInfo.divNo.substr(0,2) + '5' + this.$store.state.userInfo.divNo.substr(3,5)
      }
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_02':
        case 'SALES_MANAGER_05':
          this.clcno_lv = clcno.substr(0, 3)
          break;
        case 'SALES_MANAGER_06':
          if(this.$store.state.userInfo.userCategoryId =='A019'){
            this.clcno_lv = clcno.substr(0, 3)
            break;
          }else if(this.$store.state.userInfo.userCategoryId =='A044'){
            this.clcno_lv = clcno.substr(0, 4)
            break;
          }
          else{
            this.clcno_lv = clcno.substr(0, 5)
            break;
          }
        case 'SALES_MANAGER_03':
          this.clcno_lv = clcno.substr(0, 4)
          break;
        case 'SALES_MANAGER_04':
          this.clcno_lv = clcno.substr(0, 5)
          break;
      }
    },
    initContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
    })
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
      this.downloadData2(val);
    },
    downloadData2(val){//for 下載轄下資料

      this.changeLoading = true;
      var nowGroup2 = 'null'
      downloadChangeTrace(this.$store.state.userInfo.id, val, (this.form.vip ? "1" : "0"), this.startDate, this.endDate, nowGroup2).then(result => {
        if (result.type == "application/json") {
          //  json 為檔案下載失敗
          //  把回傳的 blob 轉為 文字檔後再用 json parse
          let reader = new FileReader();
          reader.onload = function() {
            let unicodeJsonA = JSON.parse(reader.result);
            if (unicodeJsonA.header.message) {
              vm.setToastMsg(unicodeJsonA.header.message);
            } else {
              vm.setToastMsg("伺服器連線異常");
            }
          };
          reader.readAsText(result);
        } else {
          //  成功取得檔案  進行下載
            var fileName = '';
            if(val == '2'){
              fileName = '區部總表.xlsx';
            }else if(val =='3'){
              fileName = '區部轄下通訊處總表.xlsx';
            }else if(val =='5'){
              fileName = '專招轄下推展處.xlsx';
            }else if(val =='71'){
              fileName = '專招轄下股長.xlsx';
            }else if(val =='4'){
              fileName = '展業轄下展業課.xlsx';
            }else if(val =='6'){
              fileName = '展業轄下展業區.xlsx';
            }else if(val =='74'){
              fileName = '展業轄下收展員.xlsx';
            }
          // if (this.breadcrumbs != [] && this.breadcrumbs.length > 0 && this.breadcrumbs[this.breadcrumbs.length - 1].name) {
          //   fileName += `-${this.breadcrumbs[this.breadcrumbs.length - 1].name}`;
          // }
          fileName += `-${new Date().getTime()}.xlsx`;

          saveAs(result, fileName);
        }

        this.changeLoading = false;
      });

    }
  },
  beforeMount () {
    //  設定 職等與單位代號
    this.managerKey = this.$store.state.userInfo.roleId || ''
    this.agDivNo = this.$store.state.userInfo.divNo || ''
    this.agDivName = this.$store.state.userInfo.divFullName || ''
    this.agfunctionId = this.$store.state.userInfo.functionId || ''
    // 初始化日期
    this.initDate()
  },
  mounted () {
    //  設定 單位代號 前三碼
    this.initDivNoAndClcno()
    //獲得聯絡資訊
    this.initContactInfo();
  }
}
</script>
<style scoped>
.cus-p{
  margin: 0 0 5px 0;
}
</style>
